<template>
    <div class="payment_info">
        <div class="toPay-m-r" @click="goToPay" :class="{ disable: totalCount==0}">立即支付</div>
        <div class="toPay-m-l">
            <div class="toPay-m-price">{{totalAmount}}</div>
            <div class="toPay-m-txt">应付总计: <span class="currency">￥</span></div>
            <div class="toPay-m-num">已选<span id="toPayNum">{{totalCount}}</span>张订单</div>
        </div>
    </div>
</template>

<script>
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
export default {
    name: "BookingListBottom",
    props: {
        selectedBooking: {
            type: Array
        },
        selectedOpenBooking: {
            type: Array
        }
    },
    methods: {
        getTotalAmountByBookings (bookings) {
            let amount = 0
            bookings.forEach((booking) => {
                const status = bookingStatusHelper.getBookingStatus(booking)
                if (status == 'unpaid') {
                    amount += booking.amount
                } else if (status == 'unpaidFull'){
                    amount += booking.balanceDue
                }
            })
            return amount
        },
        goToPay () {
            if (this.selectedBooking.length > 0) {
                this.$router.push({
                    name: "Pay",
                    query: {
                        // 更新为encBookingId
                        bookingId: this.selectedBooking.map(r=>r.encBookingId).join(',')
                    }
                })
            } else if (this.selectedOpenBooking.length > 0) {
                this.$router.push({
                    name: "OpenBookingDetail",
                    query: {
                        orderId: this.selectedOpenBooking[0].openBookingOrderId
                    }
                })
            }
        }
    },
    computed: {
        totalAmount () {
            if (this.selectedBooking.length > 0) {
                return this.getTotalAmountByBookings(this.selectedBooking)
            } else if (this.selectedOpenBooking.length > 0) {
                return this.getTotalAmountByBookings(this.selectedOpenBooking)
            }
            return 0
        },
        totalCount () {
          if (this.selectedBooking.length > 0) {
            let count = 0;
            this.selectedBooking && this.selectedBooking.forEach((row)=> {
              if(row.tikTokCouponStatus === 1 || row.tikTokCouponStatus === 3) {
                count++;
              }
            });
            return count > 0 ? 0 : this.selectedBooking.length;
          } else if (this.selectedOpenBooking.length > 0) {
              return this.selectedOpenBooking.length
          }
          return 0
        }
    }
}
</script>

<style lang="less" scoped>
.payment_info {
    height: 56px;
    border: 1px #fbc500 solid;
    div {
        display: inline-block;

    }
    .toPay-m-r {
        float: right;
        padding: 15px 50px;
        background-color: #fbc500;
        font-size: 18px;
        cursor: pointer;
        font-weight: 500;
    }
    .disable {
        background-color: #D2D9DE;
    }
    .toPay-m-l {
        margin-right: 16px;
        font-size: 16px;
        float: right;
        .toPay-m-price {
            margin-top: 10px;
            float: right;
            font-size: 22px;
            font-weight: 600;
            color: #ff3022;
        }
        .toPay-m-txt {
            float: right;
            padding-left: 8px;
            margin-top: 16px;
            .currency {
                color: #ff3022;
            }
        }
        .toPay-m-num {
            margin-top: 16px;
            padding: 0px 8px;
            float: right;
            border-right: solid 1px;
            #toPayNum {
                color: #0073bb;
                padding: 0px 5px;
            }
        }
    }
}
</style>
